module.exports = __webpack_public_path__ + "img/yellow.1a9b9af4.svg";